
import React, { useState } from "react"
import { md, pki } from "node-forge"
import classNames from "classnames"
import GeneratePrivateKey from "./GeneratePrivateKey.jsx"
import KeyInfo from "./KeyInfo.jsx"
import CreateCsr from "./CreateCsr.jsx"

const CsrDialog = ({csrfToken}) => {
  const [enabled, setEnabled] = useState(true)
  const [privateKeyPem, setPrivateKeyPem] = useState(null)
  const [keys, setKeys] = useState(null)

  const handleKeyCreated = (keys, pem) => {
      setPrivateKeyPem(pem)
      setKeys(keys)
  }

  if (!enabled) {
      return (<div>
        <button className="btn btn-secondary" onClick={() => setEnabled(true)}>
          Enable CSR tool
        </button>
      </div>)
  }

  return (<div className="row">
    <div className="col-md-6">
      <div className="card my-2">
        <h5 className="card-header">1. Generate private key</h5>
        <div className="card-body">
          <GeneratePrivateKey
              onKeyCreated={(keys, pem) => handleKeyCreated(keys, pem)}
          />
          <hr />
          <h4>Key info</h4>
          <KeyInfo privateKey={keys && keys.privateKey} privateKeyPem={privateKeyPem} />
        </div>
      </div>
    </div>
    <div className="col-md-6">
      <div className="card my-2">
        <h5 className="card-header">2. Create Certificate Signing Request</h5>
        <div className="card-body">
          <CreateCsr csrfToken={csrfToken} privateKey={keys && keys.privateKey} />
        </div>
      </div>
    </div>
  </div>)
}

export default CsrDialog
